let btn = document.querySelectorAll('a.button.button-ATC');
btn.forEach((btn_txt)=> {
    let testCase = btn_txt.innerText;
    let compareText = testCase.toUpperCase();
    if(compareText == 'QUICK ADD'){
        btn_txt.innerHTML = '<i class="fa-solid fa-bag-shopping"></i> BUY IT NOW';
      console.log('bag_icon is added');
    }
})